var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Table as MuiTable, TableContainer as MuiTableContainer } from '@mui/material';
import colors from '../../themes/colors';
import TableBody from './Table.Body';
import TableEmptyState from './Table.EmptyState';
import TableFooter from './Table.Footer';
import TableHeader from './Table.Header';
import useTable from './useTable';
var TableWrapper = styled(MuiTableContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  outline: 1px solid ", ";\n  border-radius: 8px;\n  height: 100%;\n  background-color: ", ";\n"], ["\n  outline: 1px solid ", ";\n  border-radius: 8px;\n  height: 100%;\n  background-color: ", ";\n"])), colors.neutral20, colors.white);
var Table = function (props) {
    var _a = props.config, config = _a === void 0 ? {} : _a, rawData = props.data, _b = props.variant, variant = _b === void 0 ? 'normal' : _b, tableWrapperRef = props.tableWrapperRef;
    var _c = useTable({ data: rawData, config: config }), columns = _c.columns, data = _c.data, collapsedRows = _c.collapsedRows, toggleRowExpand = _c.toggleRowExpand;
    // TODO(Jenky): Consider using ListItem as Row next time ???
    // https://codesandbox.io/s/m3x85517v8
    var variantToUse = config.onRowExpand ? 'expandable' : variant;
    var hasData = data.length > 0;
    var disabled = !hasData;
    var TableBodyComponent = hasData ? TableBody : TableEmptyState;
    return (_jsx(TableWrapper, __assign({ ref: tableWrapperRef }, { children: _jsxs(MuiTable, __assign({ stickyHeader: true }, { children: [_jsx(TableHeader, { disabled: disabled, data: data, columns: columns, config: config, variant: variantToUse, toggleRowExpand: toggleRowExpand, collapsedRows: collapsedRows }), _jsx(TableBodyComponent, { data: data, columns: columns, config: config, variant: variantToUse, toggleRowExpand: toggleRowExpand, collapsedRows: collapsedRows }), _jsx(TableFooter, { data: data, columns: columns, config: config, variant: variantToUse })] })) })));
};
export default Table;
var templateObject_1;
